"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.userOnboardingRoutes = void 0;
const jsx_runtime_1 = require("react/jsx-runtime");
const AcademicSpecialities_1 = require("../organisms/AcademicSpecialities/AcademicSpecialities");
const AlternativePractitionerSpecialities_1 = require("../organisms/AlternativePractitionerSpecialities/AlternativePractitionerSpecialities");
const EnthusiastSpecialities_1 = require("../organisms/EnthusiastSpecialities/EnthusiastSpecialities");
const HealthcareProviderSpecialities_1 = require("../organisms/HeathcareProviderSpecialities/HealthcareProviderSpecialities");
const MissingProfileContent_1 = require("../organisms/MissingProfileContent/MissingProfileContent");
const PrivacyPolicyContent_1 = require("../organisms/PrivacyPolicyContent/PrivacyPolicyContent");
const ProfileCompleteContent_1 = require("../organisms/ProfileCompleteContent/ProfileCompleteContent");
const PushNotificationsContent_1 = __importDefault(require("../organisms/PushNotificationsContent/PushNotificationsContent"));
const RedeemCodePageContentGrasshopper_1 = require("../organisms/RedeemCodePageContentGrasshopper/RedeemCodePageContentGrasshopper");
const RegionSelectionContent_1 = require("../organisms/RegionSelectionContent/RegionSelectionContent");
const SelectUserTypePageContent_1 = require("../organisms/SelectUserTypePageContent/SelectUserTypePageContent");
const StudentGraduationYearContent_1 = require("../organisms/StudentGraduationYearContent/StudentGraduationYearContent");
const StudentSpecialities_1 = require("../organisms/StudentSpecialities/StudentSpecialities");
const SubscriptionsSheetContent_1 = __importDefault(require("../organisms/SubscriptionsSheetContent/SubscriptionsSheetContent"));
const WelcomePageContent_1 = require("../organisms/WelcomePageContent/WelcomePageContent");
const PageTemplate_1 = require("../templates/PageTemplate/PageTemplate");
const ProfileSurveyTemplate_1 = require("../templates/ProfileSurveyTemplate/ProfileSurveyTemplate");
const RegularWrapper_1 = require("../templates/RegularWrapper/RegularWrapper");
const Route_1 = require("./Route");
exports.userOnboardingRoutes = [
    {
        path: Route_1.Route.Base,
        element: (0, jsx_runtime_1.jsx)(PageTemplate_1.PageTemplate, { "data-e2e": 'PageTemplate' }),
        children: [
            {
                path: Route_1.Route.SelectRegion,
                element: (0, jsx_runtime_1.jsx)(RegularWrapper_1.RegularWrapper, { "data-e2e": 'RegularWrapper' }),
                children: [
                    {
                        index: true,
                        element: (0, jsx_runtime_1.jsx)(RegionSelectionContent_1.RegionSelectionContent, { "data-e2e": 'RegionSelectionContent' }),
                    },
                    {
                        path: Route_1.Route.PrivacyPolicy,
                        element: (0, jsx_runtime_1.jsx)(PrivacyPolicyContent_1.PrivacyPolicyContent, { "data-e2e": 'PrivacyPolicyContent' }),
                    },
                ],
            },
            {
                path: Route_1.Route.PushNotifications,
                element: (0, jsx_runtime_1.jsx)(RegularWrapper_1.RegularWrapper, { "data-e2e": 'RegularWrapper' }),
                children: [
                    {
                        index: true,
                        element: (0, jsx_runtime_1.jsx)(PushNotificationsContent_1.default, { "data-e2e": 'PushNotificationsContent' }),
                    },
                ],
            },
            {
                path: Route_1.Route.SubscriptionsSheet,
                element: (0, jsx_runtime_1.jsx)(RegularWrapper_1.RegularWrapper, { "data-e2e": 'RegularWrapper' }),
                children: [
                    {
                        index: true,
                        element: (0, jsx_runtime_1.jsx)(SubscriptionsSheetContent_1.default, { "data-e2e": 'SubscriptionsSheetContent' }),
                    },
                ],
            },
            {
                path: Route_1.Route.ProfileSurvey,
                element: (0, jsx_runtime_1.jsx)(ProfileSurveyTemplate_1.ProfileSurveyTemplate, { "data-e2e": 'ProfileSurveyTemplate' }),
                children: [
                    {
                        index: true,
                        element: (0, jsx_runtime_1.jsx)(WelcomePageContent_1.WelcomePageContent, { "data-e2e": 'WelcomePageContent' }),
                    },
                    {
                        path: Route_1.Route.MissingProfile,
                        element: (0, jsx_runtime_1.jsx)(MissingProfileContent_1.MissingProfileContent, { "data-e2e": 'MissingProfileContent' }),
                    },
                    {
                        path: Route_1.Route.SelectUserType,
                        element: ((0, jsx_runtime_1.jsx)(SelectUserTypePageContent_1.SelectUserTypePageContentWithDelayedAppearance, { nextRoute: Route_1.Route.SelectSpeciality, "data-e2e": 'SelectUserTypePageContentWithDelayedAppearance' })),
                    },
                    {
                        path: Route_1.Route.SelectSpeciality,
                        children: [
                            {
                                path: Route_1.Route.Student,
                                element: ((0, jsx_runtime_1.jsx)(StudentSpecialities_1.StudentSpecialities, { nextRoute: Route_1.Route.SelectGraduationDate, "data-e2e": 'StudentSpecialities' })),
                            },
                            {
                                path: Route_1.Route.Academic,
                                element: ((0, jsx_runtime_1.jsx)(AcademicSpecialities_1.AcademicSpecialities, { nextRoute: Route_1.Route.ProfileComplete, "data-e2e": 'AcademicSpecialities' })),
                            },
                            {
                                path: Route_1.Route.HealthcareProvider,
                                element: ((0, jsx_runtime_1.jsx)(HealthcareProviderSpecialities_1.HealthcareProviderSpecialities, { nextRoute: Route_1.Route.ProfileComplete, "data-e2e": 'HealthcareProviderSpecialities' })),
                            },
                            {
                                path: Route_1.Route.AlternativePractitioner,
                                element: ((0, jsx_runtime_1.jsx)(AlternativePractitionerSpecialities_1.AlternativePractitionerSpecialities, { nextRoute: Route_1.Route.ProfileComplete, "data-e2e": 'AlternativePractitionerSpecialities' })),
                            },
                            {
                                path: Route_1.Route.Enthusiast,
                                element: ((0, jsx_runtime_1.jsx)(EnthusiastSpecialities_1.EnthusiastSpecialities, { nextRoute: Route_1.Route.ProfileComplete, "data-e2e": 'EnthusiastSpecialities' })),
                            },
                        ],
                    },
                    {
                        path: Route_1.Route.SelectGraduationDate,
                        element: ((0, jsx_runtime_1.jsx)(StudentGraduationYearContent_1.StudentGraduationYearContent, { nextRoute: Route_1.Route.ProfileComplete, "data-e2e": 'StudentGraduationYearContent' })),
                    },
                    {
                        path: Route_1.Route.ProfileComplete,
                        element: (0, jsx_runtime_1.jsx)(ProfileCompleteContent_1.ProfileCompleteContentWithDelayedAppearance, { "data-e2e": 'ProfileCompleteContentWithDelayedAppearance' }),
                    },
                ],
            },
            {
                path: Route_1.Route.RedeemCode,
                element: (0, jsx_runtime_1.jsx)(RedeemCodePageContentGrasshopper_1.RedeemCodePageContentGrasshopper, { "data-e2e": 'RedeemCodePageContentGrasshopper' }),
            },
        ],
    },
];
